export class AppSettings {

	static readonly permisos = {
		COLABORADOR  : 1,
		INSCRIBIR : 2,
		DISENIO : 4,
		PROFESOR : 8,
		ENCARGADO : 16,
		FINANZAS : 32,
		GERENTE_SUCURSAL : 64,
		JEFE : 128
	};

	public static get API_INSCRIPCIONES(): Object { 
		return 'https://inscripciones.softmart.mx';
	}
	public static get API_SEIZA(): Object {
		//return 'http://localhost:3333';
		return 'http://192.241.208.83:3333';
	}

}


// WEBPACK FOOTER //
// ./src/app/_models/app.settings.ts